import { TextFieldProps } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import dayjs, { Dayjs } from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";

type DatePickerProps = {
  name: string;
  label: string;
  minDate?: any;
  maxDate?: any;
  onChange?: (date: any) => void;
  defaultValue?: Dayjs | null;
  disabled?: boolean;
} & TextFieldProps;

function RHFDatePicker({
  name,
  label,
  sx,
  minDate,
  maxDate,
  onChange,
  required,
  disabled,
}: DatePickerProps) {
  const { control, setValue, trigger } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const value = field.value ? dayjs(field.value) : null;

        return (
          <DatePicker
            {...field}
            value={value}
            onChange={(date: Dayjs | null) => {
              setValue(name, date);
              trigger(name);
              field.onChange(date);
              if (onChange) onChange(date);
            }}
            label={label}
            disabled={disabled}
            minDate={minDate}
            maxDate={maxDate}
            sx={sx}
            slotProps={{
              textField: {
                error: !!error,
                helperText: error?.message || null,
                required,
              },
            }}
          />
        );
      }}
    />
  );
}

export { RHFDatePicker };
